"use strict";

exports.__esModule = true;
exports.default = normalize;

/*
 * @Author: lijianzhang
 * @Date: 2018-10-20 03:38:49
 * @Last Modified by: lijianzhang
 * @Last Modified time: 2018-12-16 13:11:49
 *
 */
// template 写入 vue组件
// 编译.vue时用到
function normalize(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {};

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}